<template>
  <div
    class="page-loading"
    :class="`mode-${mode}`"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <div class="loading-content">
      <div class="loading-wordmark" aria-hidden="true">
        <span class="letter letter-x">x</span>
        <span class="letter letter-y">y</span>
        <span class="letter letter-o">o</span>
      </div>
      <p>{{ text }}</p>
      <small v-if="hint">{{ hint }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageLoading",
  props: {
    text: { type: String, default: "正在准备页面" },
    hint: { type: String, default: "" },
    mode: { type: String, default: "dashboard" },
  },
};
</script>

<style scoped lang="scss">
.page-loading {
  z-index: 70;
  display: grid;
  place-items: center;
  color: var(--xyo-ink, #302b38);
  background: rgba(247, 245, 250, 0.9);

  &.mode-dashboard {
    position: fixed;
    inset: 68px 0 0 252px;
  }

  &.mode-standalone {
    position: absolute;
    inset: 0;
    min-height: 100vh;
  }
}

.loading-content {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: transparent;
  animation: xyo-loading-enter 220ms ease-out both;

  p {
    margin: 8px 0 0;
    color: var(--xyo-muted, #827b8c);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    white-space: nowrap;
  }

  small {
    margin-top: 7px;
    color: var(--xyo-muted, #827b8c);
    font-size: 12px;
    line-height: 1.5;
  }
}

.loading-wordmark {
  position: relative;
  width: 56px;
  height: 30px;
  color: var(--xyo-ink-strong, #27222e);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
  font-size: 28px;
  font-weight: 760;
  font-variation-settings: "wght" 760;
  line-height: 30px;

  .letter {
    position: absolute;
    top: 0;
    left: 50%;
    width: 18px;
    margin-left: -9px;
    text-align: center;
    will-change: color, opacity, transform;
  }

  .letter-x {
    animation: xyo-letter-x 1.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }

  .letter-y {
    animation: xyo-letter-y 1.8s cubic-bezier(0.22, 1, 0.36, 1) infinite;
  }

  .letter-o {
    animation: xyo-letter-o 1.8s cubic-bezier(0.22, 1, 0.36, 1) infinite;
  }
}

@media (max-width: 1180px) {
  .page-loading.mode-dashboard {
    left: 226px;
  }
}

@media (max-width: 768px) {
  .page-loading.mode-dashboard {
    top: 68px;
    left: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-content,
  .loading-wordmark .letter {
    animation: none;
  }

  .loading-wordmark .letter-x {
    transform: translateX(-18px);
  }

  .loading-wordmark .letter-y {
    color: var(--xyo-ink-strong, #27222e);
    opacity: 1;
    transform: translateX(0);
  }

  .loading-wordmark .letter-o {
    color: var(--xyo-primary, #c94225);
    opacity: 1;
    transform: translateX(18px);
  }
}

@keyframes xyo-loading-enter {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes xyo-letter-x {
  0%, 14%, 100% {
    transform: translateX(0);
  }
  24%, 40% {
    transform: translateX(-9px);
  }
  50%, 76% {
    transform: translateX(-18px);
  }
  88% {
    transform: translateX(-7px);
  }
}

@keyframes xyo-letter-y {
  0%, 15%, 94%, 100% {
    color: var(--xyo-primary, #c94225);
    opacity: 0;
    transform: translate(9px, 4px) scale(0.94);
  }
  24%, 40% {
    color: var(--xyo-primary, #c94225);
    opacity: 1;
    transform: translate(9px, 0) scale(1);
  }
  50%, 76% {
    color: var(--xyo-ink-strong, #27222e);
    opacity: 1;
    transform: translate(0, 0) scale(1);
  }
  88% {
    color: var(--xyo-ink-strong, #27222e);
    opacity: 0;
    transform: translate(-2px, -2px) scale(0.96);
  }
}

@keyframes xyo-letter-o {
  0%, 41%, 89%, 100% {
    color: var(--xyo-primary, #c94225);
    opacity: 0;
    transform: translate(18px, 4px) scale(0.94);
  }
  50%, 76% {
    color: var(--xyo-primary, #c94225);
    opacity: 1;
    transform: translate(18px, 0) scale(1);
  }
  88% {
    color: var(--xyo-primary, #c94225);
    opacity: 0;
    transform: translate(18px, -2px) scale(0.96);
  }
}
</style>
